module.exports = __webpack_public_path__ + "static/img/far1_active.e66fbfc8.png";